<app-page-body>
  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ "common.pricePerPart" | translate }}
          </legend>

          <div class="row tw-mb-10">
            <!-- title -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-[275px]"
                enumName="SmsCp"
                [label]="'common.aggregator'"
                [control]="form?.get('smsCp')"
                [(value)]="model.SmsCp"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- postalCode -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-[275px]"
                enumName="PhoneNumberRegions"
                [label]="'common.region'"
                [control]="form?.get('region')"
                [(value)]="model.Region"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- form btns-->

            <!-- <app-form-btns
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              [loading]="loading"
              [form]="form"
              [hasMaxWidth]="false"
              [isEdit]="formPageConfig.isEditMode"
              [customTitle]="'common.calculate'"
              [showCloseBtn]="false"
              (onSubmit)="onSubmit()"
            >
            </app-form-btns> -->
            <!-- form btns-->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <section>
                <div class="">
                  <div class="tw-flex tw-h-[60px]">
                    <!-- submit btn -->
                    <button
                      type="button"
                      (click)="onSubmit()"
                      class="btn tw-w-full tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-mb-1 tw-h-full btn-primary"
                      [themeColor]="'btn'"
                      [isAllowSetTheme]="true"
                    >
                      <ng-container *ngIf="!loading">
                        <span class="submit-button-text-color">
                          {{ "common.calculate" | translate }}</span
                        >
                      </ng-container>

                      <!-- loading -->
                      <ng-container *ngIf="loading">
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span class="sr-only">Loading...</span>
                      </ng-container>
                    </button>
                  </div>
                </div>
              </section>
            </div>

            @if (pricePerPart || pricePerPart == 0) {
            <div
              class="fw-bold tw-rounded-[10px] tw-flex tw-items-center tw-justify-between rounded tw-bg-gray-100 dark:tw-bg-dark-200 tw-p-5 sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-h-fit"
            >
              <span class="dark:tw-text-gray-200">{{
                "common.pricePerPart" | translate
              }}</span>
              <span
                class="tw-text-primary-400 tw-p-1 tw-min-w-10 tw-text-center tw-font-semibold tw-bg-primary-100 tw-rounded-md tw-border tw-border-primary-400 dark:tw-bg-primary-950/40"
              >
                {{ pricePerPart | numberSeparator }}
              </span>
            </div>
            }
          </div>
        </fieldset>
      </section>
    </form>
  </div>
</app-page-body>
